module.exports = __webpack_public_path__ + "static/media/40-6.5bef2140.mp3";